import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHElevenResult',
    name: 'PageOneHElevenResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHEleven/result.vue'),
  },
  {
    path: '/IFPageOneHElevenLoading',
    name: 'PageOneHElevenLoading',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHEleven/loading.vue'),
  },
  {
    path: '/IFPageOneHElevenSecResult',
    name: 'PageOneHElevenSecResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHEleven/secResult.vue'),
  },
  {
    path: '/IFPageOneHElevenGuide',
    name: 'PageOneHElevenGuide',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHEleven/guide.vue'),
  },
];
